export namespace AlternativeActions {
  export class SetSelected {
    static readonly type = '[Alternative] Set Selected Alternative';
    constructor(public alternativeUuid: string | null) {}
  }
  export class Confirm {
    static readonly type = '[Alternative] Confirm';
    constructor(
      public projectId: string,
      public selectionId: string,
      public alternativeUuid: string
    ) {}
  }
}
